export const type = 'ECD/update';

export default payload => ({
  type,
  error: false,
  payload,
});
